<template>
  <view>
    <view v-for="pageContentInfo in pageContentInfoList" :key="pageContentInfo.id">
      <view v-for="children in pageContentInfo.childrenList" :key="children.id">
        <el-card v-if="children.type==='section'" style="white-space: pre-line;" :header="children.content" type="line" padding>
          <view v-for="childrenInfo in children.childrenList" :key="childrenInfo.id">
            <text v-if="childrenInfo.type==='text'" class="text">
              {{childrenInfo.content}}
            </text>
            <image v-if="childrenInfo.type==='image'" style="height: 600px;"
                   :src="`${baseUrl}view/${childrenInfo.content}`" mode="aspectFit"></image>
            <video v-if="childrenInfo.type==='video'" width="600" controls
                   :src="`${baseUrl}view/${childrenInfo.content}`" ></video>
          </view>
        </el-card>
      </view>
    </view>
  </view>

</template>

<script>
import {
  ref
} from "vue";
import {
  getBaseUrl
} from "@/utils/base.js";
import {
  getPageContentInfoByChildrenListPage
} from "@/utils/pageContentInfo.js";
import {useRoute} from "vue-router/dist/vue-router";

const pageContentInfoList = ref([])
const type = ref('');

let baseUrl = getBaseUrl();
export default {
  name: "pageContentInfo",
  data() {
    return {
      pageContentInfoList: pageContentInfoList,
      baseUrl: baseUrl,
    }
  },
  async created() {
    const route = useRoute();
    type.value = route.query.type;
    console.log(type.value);
    if (type.value) {
      await getPageContentInfoByChildrenListPage(type.value, pageContentInfoList);
      console.log(pageContentInfoList.value)
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.text {
  display: flex;
  flex-direction: column;
  font-size: 1rem;
}

.center_text {
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中 */
}

.marginTop {
  margin-top: 10px;
}

.orangeRedColor {
  color: orangered;
}

.uni-section-header__content {
  font-size: 1rem;
}
</style>
